
import { useEffect, useState, useContext, CSSProperties } from "react";
import useToken from "../../hooks/useToken";
import { BrowserRouter, Route, Switch, useParams } from "react-router-dom";
import { DataContext, DataProvier } from "./data/DataContext";
import { LineProgressBar, ButtonCtrl, PagesTitleCtrl, ModalMsgCtrl } from './components'
import { siteTitleMain, lstPageTitle, pagesType, dataDefault, catPaymentFrequency } from './data/MochaData';
import { SiteConfig } from './data/Data';
import { usePage, useModal } from './hook';
import { Step } from "./step";
import http, { getConfig } from "../../services/http";
import { endPoints } from "../../utils/constanst";
import {
    ValidData,
    GetDataEnte,
    BuilDataToUpdate,
    BuildPayment,
    RoundToTwo,
    BuildSaveCard,
    buildDataNotification,
    BuildDataCICAC,
    BuildDataKycNatural,
    DataBuildNotification,
    DataBuildNotificationPol,
    DataBuildFileToPol
} from './data/Help'
import './Auto_Emision_CR.css'
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { DecryptData, ValidateExpirationDate } from '../../utils/helpMain'
import { catCivilStatus } from './data/MochaData'
import Modal from 'react-modal'
import { IconWaitEvicertia, IconError } from './img'
import { SitioOportunity } from '../../utils/global'


const Auto_Emision_CR = () => {
    const { loading } = useToken();

    useEffect(() => {
        if (!loading) {
            const preloader: any = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event: any) => {
                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }
        }
    }, [loading]);

    if (loading) return (<></>);
    return (
        <DataProvier loading={loading} >
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/cr/auto/emision/:id" component={Layout} />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location }: IPropsParam) => {
    const { AutoEmisionCR, setAutoEmisionCR } = useContext(DataContext);
    const page = usePage(SiteConfig.InitPage, lstPageTitle);
    const modalLoading = useModal({ isloading: true } as IModalProps);
    const modalWaitEvicertia = useModal({ active: false } as IModalProps);
    const modalInvalidRequirements = useModal({ active: false } as IModalProps);
    const modalUrlNoValid = useModal({ active: false } as IModalProps);
    const modalErrorPV = useModal({ active: false } as IModalProps)
    const modalPlateExists = useModal({ active: false } as IModalProps)
    const modalMsg = useModal({ isloading: false } as IModalProps);
    const [connection, setConnection] = useState<HubConnection>();
    const { id } = useParams<any>();

    useEffect(() => {
        const config = getConfig();
        const url = `${config.url_api}${endPoints.notificationHub}`;
        const newConnection = new HubConnectionBuilder()
            .withUrl(url)
            .configureLogging(LogLevel.Debug)
            .withAutomaticReconnect()
            .build();
        setConnection(newConnection);
    }, [])

    useEffect(() => {
        //ConnectNotificationHub();
        GetInitStep1();

    }, [])


    useEffect(() => {
        if (connection?.state === HubConnectionState.Disconnected) {
            connection.start().then(() => {
                connection.on("AcceptCondition", (accepted) => {
                    modalWaitEvicertia.hide();
                    if (accepted)
                        page.ViewPage(pagesType.PV)
                    else
                        SendNotificationAutoNew('RechazoEvicertia').finally(() => page.ViewPage(pagesType.NoAccept))

                })
            }).catch(e => console.log('Connection failed: ', e));
        }
    }, [connection])

    useEffect(() => {
        if (ValidData(AutoEmisionCR.countryOfOrigin))
            GetCatalogProvince();
        else
            setAutoEmisionCR({ ...AutoEmisionCR, catProvince: [], province: '' })
    }, [AutoEmisionCR.countryOfOrigin])

    useEffect(() => {
        if (ValidData(AutoEmisionCR.canton))
            GetCatalogDisctrict();
        else
            setAutoEmisionCR({ ...AutoEmisionCR, catDistrict: [], district: '' })
    }, [AutoEmisionCR.canton])

    useEffect(() => {
        if (ValidData(AutoEmisionCR.province))
            GetCatalogCanton();
        else
            setAutoEmisionCR({ ...AutoEmisionCR, catCanton: [], canton: '' })
    }, [AutoEmisionCR.province])


    useEffect(() => {
        if (AutoEmisionCR.acceptSaveCard === 'S') {
            modalLoading.show('Cargando bancos...')
            http(endPoints.banks).get()
                .then(x => {
                    setAutoEmisionCR({ ...AutoEmisionCR, catBank: x })
                }).finally(() => modalLoading.hide())
        }
        else
            setAutoEmisionCR({ ...AutoEmisionCR, cardType: '', cardCountry: '', issuingBank: '', acceptCardTerm: false })
    }, [AutoEmisionCR.acceptSaveCard])

    const GetCatalogProvince = () => {
        modalLoading.setTextLoading('Cargando provincias');
        http(endPoints.department(AutoEmisionCR.countryOfOrigin)).get()
            .then((x) => setAutoEmisionCR({ ...AutoEmisionCR, catProvince: x, province: '' }))
            .finally(() => modalLoading.hide())
    }

    const GetCatalogDisctrict = () => {
        modalLoading.setTextLoading('Cargando distrito');
        http(endPoints.district(AutoEmisionCR.countryOfOrigin, AutoEmisionCR.province, AutoEmisionCR.canton)).get()
            .then((x) => setAutoEmisionCR({ ...AutoEmisionCR, catDisctrict: x, district: '' }))
            .finally(() => modalLoading.hide())
    }

    const GetCatalogCanton = () => {
        modalLoading.setTextLoading('Cargando canton');
        http(endPoints.country(AutoEmisionCR.countryOfOrigin, AutoEmisionCR.province)).get()
            .then((x) => setAutoEmisionCR({ ...AutoEmisionCR, catCanton: x, canton: '' }))
            .finally(() => modalLoading.hide())
    }

    const GetInitStep1 = async () => {
        if (!ValidData(id) || id.length % 2 !== 0) return;

        const normalizedId = DecryptData(id.toString());
        modalLoading.show('Cargando cotización...');

        try {
            const [nationality, profession, countries, transmission, vehicleClass, doors, cylinders, fuel, policyResult, invalidReqs, approvedEvicertia] =
                await Promise.allSettled([
                    GetCatalog('nacionalidad'),
                    GetCatalog('profesion'),
                    GetCatalog('paises'),
                    http(endPoints.vhTransmision).get(),
                    http(endPoints.vhClaseVehiculo).get(),
                    http(endPoints.vhNoPuertas).get(),
                    http(endPoints.vhCilindros).get(),
                    http(endPoints.vhCombustible).get(),
                    http(endPoints.getPolicy(normalizedId)).get(),
                    http(endPoints.catalogRiesgo).get(),
                    http(endPoints.getApprovedPolicyById(normalizedId)).get()
                ]);

            if (policyResult.status !== 'fulfilled') {
                modalUrlNoValid.show();
                return;
            }

            const pol = policyResult.value;

            if (![0, 1].includes(pol.estado)) {
                modalUrlNoValid.show();
                return;
            }

            const safeGet = (res: any) => (res.status === 'fulfilled' ? res.value : []);
            const getValueOrEmpty = (value: string | null | undefined) => (!value || value === '0' ? '' : value);

            const catCivil = catCivilStatus.find(x => x.text2 === pol.aseguradoNavigation.estadoCivil);
            const payment = catPaymentFrequency.find(x => x.value === pol.frecuencia);

            const hasSpecialEquipment = !!(pol.oa?.oA_EquipoEspecial?.length > 0);
            const fees = payment ? RoundToTwo(pol.total / (payment.value2 || 1)).toString() : '';
            const paymentDetail = payment?.text ?? '';

            setAutoEmisionCR({
                ...AutoEmisionCR,
                ente: pol.aseguradoNavigation.id,
                idbrokerage: pol.productor,
                catNationality: safeGet(nationality),
                catProfesion: safeGet(profession),
                catCountryOfOrigin: safeGet(countries),
                catVehicleTransmission: safeGet(transmission),
                catVehicleClass: safeGet(vehicleClass),
                catVehicleDoorNumber: safeGet(doors),
                catvehicleCylinderNumber: safeGet(cylinders),
                catvehicleFuel: safeGet(fuel),
                catInvalidRequirements: safeGet(invalidReqs),
                idPol: pol.id,
                vehicleNew: pol.oa.auNuevo,
                vehicleBrand: pol.oa.auMarca,
                vehicleModel: pol.oa.auModelo,
                vehicleYear: pol.oa.auAnio,
                typeDocument: pol.aseguradoNavigation.tipoId,
                identification: pol.aseguradoNavigation.numId,
                insuredMail: pol.aseguradoNavigation.email,
                insuredName: `${pol.aseguradoNavigation.nombre} ${pol.aseguradoNavigation.apellido}`,
                insuredPhonNumber: pol.aseguradoNavigation.telefonoCelular,
                nationality: pol.aseguradoNavigation.nacionalidad?.toString(),
                sex: pol.aseguradoNavigation.sexo,
                birthdate: ValidData(pol.aseguradoNavigation.fechaNacimiento)
                    ? new Date(pol.aseguradoNavigation.fechaNacimiento)
                    : undefined,
                profession: pol.aseguradoNavigation.profesion,
                civilStatus: catCivil?.value ?? '',
                address: pol.aseguradoNavigation.direccion,
                homePhone: pol.aseguradoNavigation.telefonoCasa,
                monthlyIncome: getValueOrEmpty(pol.aseguradoNavigation.ingresoMensual),
                company: pol.aseguradoNavigation.empreLab,
                countryOfOrigin: pol.aseguradoNavigation.paisOrigen,
                ownHouse: pol.aseguradoNavigation.casaPropia === true ? 'S' : 'N',
                haveChildren: pol.aseguradoNavigation.tieneHijos === true ? 'S' : 'N',
                ownVehicle: pol.aseguradoNavigation.vehiculoPropio === true ? 'S' : 'N',
                hasSpecialEquipment,
                idPlan: pol.planNavigation.id,
                maxDayPlan: pol.planNavigation.mDiaMaxVigencia,
                currencyPlan: pol.planNavigation.moneda,
                sumInsured: pol.sa,
                paymentFrequency: pol.frecuencia,
                totalBonus: pol.total,
                paymentFrequencyDetail: paymentDetail,
                paymentFrequencyDetailStr: paymentDetail,
                feePay: fees,

                downloadReceipts: DownloadReceipts,
                downloadPolicy: DownloadPolicy,
                increment: page.Increment,
                sendNotificationEvicertia: SendNotificationEvicertia,
                getDataByPlate: GetDataByPlate,
                issuePolice: IssuePolice,
                init: true
            });

            if (approvedEvicertia.status === 'fulfilled' && approvedEvicertia.value?.aprobado)
                page.ViewPage(pagesType.PV);

        } catch (error) {
            console.error('Error al obtener datos:', error);
            modalUrlNoValid.show();
        } finally {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            modalLoading.hide();
        }
    };

    const GetCatalog = (dat: string) => http(endPoints.catalog2(dat)).get()

    const ConnectNotificationHub = () => {
        const config = getConfig();
        const url = `${config.url_api}${endPoints.notificationHub}`;
        const newConnection = new HubConnectionBuilder()
            .withUrl(url)
            .configureLogging(LogLevel.Error)
            .withAutomaticReconnect()
            .build();
        setConnection(newConnection);
    }

    const ValidateRequirements = (typeRisk: typeRisk, risk: string) => {
        let data = AutoEmisionCR.catInvalidRequirements.find(x => x.idMaestro === typeRisk.toString() && x.valor.toString() === risk.toString())
        if (data === null || data === undefined)
            return { isValid: true, typeRisk: typeRisk }
        return { isValid: false, typeRisk: typeRisk }
    }

    const SendNotificationEvicertia = (auto: IAutoEmisionCR) => {

        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;
        let data = {
            Nombre: auto.insuredName,
            Correo: auto.insuredMail,
            IdPoliza: auto.idPol
        }

        modalLoading.show('Enviando notificación...');
        http(endPoints.sendAcceptNotification).post(data)
            .then(x => {
                http(endPoints.associateConnetion(x.message))
                    .get()
                    .then(() => {
                        connection?.invoke('AssociateConnection', x.message)
                        modalWaitEvicertia.show();
                    })
                    .catch(() => modalLoading.hide())
                    .finally(() => modalLoading.hide())
            }).catch(x => () => modalLoading.hide())

    }


    const SendNotificationEvicertia2 = () => {

        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;
        let data = {
            Nombre: AutoEmisionCR.insuredName,
            Correo: AutoEmisionCR.insuredMail,
            IdPoliza: AutoEmisionCR.idPol
        }

        modalLoading.show('Enviando notificación...');
        http(endPoints.sendAcceptNotification).post(data)
            .then(x => {
                http(endPoints.associateConnetion(x.message))
                    .get()
                    .then(() => {
                        connection?.invoke('AssociateConnection', x.message)
                        modalWaitEvicertia.show();
                    })
                    .catch(() => modalLoading.hide())
                    .finally(() => modalLoading.hide())
            }).catch(x => () => modalLoading.hide())

    }


    const UpdateEnte = () => http(endPoints.updateEnte).post(GetDataEnte(AutoEmisionCR));

    const UpdatePol = () => http(endPoints.updateAutoPolicy).post(BuilDataToUpdate(AutoEmisionCR));

    const SavePersonalData = async () => {
        modalLoading.show('Actualizando...');
        Promise.allSettled([
            UpdateEnte(),
            SendNotificationAutoNew('DocumentoIdentidad'),
            UploadFileToPol('DocumentoIdentidad')
        ]).then(async (x) => {
            modalLoading.hide();
            if (x[0].status === 'rejected')
                return;

            let isValidNationality = ValidateRequirements('nacionalidad', AutoEmisionCR.nationality)
            if (isValidNationality.isValid === false) {
                modalLoading.show('Validando...');
                const dataNotification = await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'NO_NACIONALIDAD', undefined)
                http(endPoints.sendNotficationNew)
                    .post(dataNotification)
                    .finally(() => { modalInvalidRequirements.show(); modalLoading.hide(); return; })
            }

            let isValidProfesion = ValidateRequirements('profesion', AutoEmisionCR.profession)
            if (isValidProfesion.isValid === false) {
                modalLoading.show('Validando...');
                const dataNotification = await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'NO_PROFESION', undefined)
                http(endPoints.sendNotficationNew)
                    .post(dataNotification)
                    .finally(() => { modalInvalidRequirements.show(); modalLoading.hide(); return; })
            }

            // if (AutoEmisionCR.civilStatus.toString() === dataDefault.civilStatusSpouse)
            //     page.Increment();
            // else
            //     page.ViewPage(pagesType.CICAC);

            page.Increment();

        })
    }

    const SaveStepCICACKyc = () => {
        modalLoading.show('Actualizando...')
        Promise.allSettled([
            SaveCICAC(),
            SaveKycNatural()
        ]).then((x) => {
            modalLoading.hide();
            if (x[0].status === 'fulfilled' && x[1].status === 'fulfilled') {
                if (AutoEmisionCR.obligatedSubjectsPEPQuestion1 === 'S')
                    page.Increment();
                else
                    page.ViewPage(pagesType.VehicleDetails);
            }

        }).catch(() => {
            modalLoading.hide();
        })


    }

    const SaveCICAC = () => http(endPoints.addCICAC).post(BuildDataCICAC(AutoEmisionCR));
    const SaveKycNatural = () => http(endPoints.saveKycNatural).post(BuildDataKycNatural(AutoEmisionCR))

    const ValidDatePolicy = (x: IPolicyTechnicalDataDetailDto) => (x.estado === 'V' && AutoEmisionCR.autoInsuranceStartDate !== undefined && (new Date(x.fechaDesde) <= AutoEmisionCR.autoInsuranceStartDate && new Date(x.fechaHasta) >= AutoEmisionCR.autoInsuranceStartDate))

    const ValidPlate = () => {
        modalLoading.show("Validando datos...")

        Promise.allSettled([
            http(endPoints.getTechnicalDataPol2).post({
                placa: AutoEmisionCR.vehiclePlate
            }),
            http(endPoints.getTechnicalDataPol2).post({
                chasis: AutoEmisionCR.vehicleChasis
            })
        ]).then((x) => {
            if ((x[0].status === 'fulfilled' && ValidDatePolicy(x[0].value)) || (x[1].status === 'fulfilled' && ValidDatePolicy(x[1].value))) {
                modalLoading.hide();
                modalPlateExists.show();
                return;
            }
            SaveVehicleDetail();
        })

        // http(endPoints.getTechnicalDataPol2).post({
        //     placa: AutoEmisionCR.vehiclePlate
        // }).then((x: IPolicyTechnicalDataDetailDto) => {
        //     console.log(AutoEmisionCR.autoInsuranceExpirationDate);

        //     if (x.estado === 'V' && AutoEmisionCR.autoInsuranceStartDate !== undefined && (new Date(x.fechaDesde) <= AutoEmisionCR.autoInsuranceStartDate && new Date(x.fechaHasta) >= AutoEmisionCR.autoInsuranceStartDate)) {
        //         console.log('entra')
        //         modalLoading.hide();
        //         modalPlateExists.show();
        //         return;
        //     }
        //     else {
        //         console.log('valid')
        //     }

        //     modalLoading.hide();
        //     // SaveVehicleDetail();
        // }).catch(() => {
        //     //  SaveVehicleDetail();
        // })
    }

    const SaveVehicleDetail = () => {


        modalLoading.show('Actualizando...')
        let lstPromise = [
            UpdatePol(),
            SendNotificationAutoNew('FacturaProforma'),
            UploadFileToPol('FacturaProforma')
        ]

        if (AutoEmisionCR.hasSpecialEquipment) {
            lstPromise.push(SendNotificationAutoNew('FacturaEquiposEspeciales'))
            lstPromise.push(UploadFileToPol('FacturaEquiposEspeciales'))
        }

        Promise.allSettled(lstPromise).then(x => {
            modalLoading.hide();
            if (x[0].status === 'rejected')
                return;
            if (AutoEmisionCR.vehicleNew === false)
                page.ViewPage(pagesType.UsedCarFile);
            else if (AutoEmisionCR.vehicleNew === true)
                page.Increment();
        }).finally(() => modalLoading.hide())
    }

    const SavePersonalDataSpouse = () => {
        modalLoading.show('Actualizando...');
        Promise.allSettled([
            UpdateEnte(),
            SaveKycNatural()
        ]).then(x => {
            modalLoading.hide();
            if (x[0].status === 'fulfilled' && x[0].status === 'fulfilled')
                page.Increment()
        })
    }


    const SaveUsedcar = () => {
        modalLoading.show('Subiendo imagenes...')
        Promise.allSettled([
            SendNotificationAutoNew('InspeccionVehiculo'),
            UploadFileToPol("InspeccionVehiculo")
        ]).then(x => page.ViewPage(pagesType.Evicertia)).finally(() => modalLoading.hide())

    }

    const SendNotificationAuto = async (type: typeNotificationAutoEmisionCR) => {
        let data = await buildDataNotification(AutoEmisionCR, type);
        return http(endPoints.notificationAutoCR).multipleFileData(data.polInfo, data.attach);
    }

    const SendNotificationAutoNew = async (type: typeNotificationAutoEmisionCR) => {
        let lstFile: Array<File> = [];
        switch (type) {
            case "DocumentoIdentidad":
                if (AutoEmisionCR.identificationBackImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.identificationBackImage.length; i++) {
                        lstFile.push(AutoEmisionCR.identificationBackImage[i])
                    }
                }
                if (AutoEmisionCR.identificationFrontImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.identificationFrontImage.length; i++) {
                        lstFile.push(AutoEmisionCR.identificationFrontImage[i])
                    }
                }
                return http(endPoints.sendNotficationNew).post(await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'IDENTIFICACION', lstFile));
            case 'FacturaProforma':
                if (AutoEmisionCR.invoiceFile !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.invoiceFile.length; i++) {
                        lstFile.push(AutoEmisionCR.invoiceFile[i])
                    }
                }
                return http(endPoints.sendNotficationNew).post(await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'FACTURA_PROFORMA', lstFile));
            case 'FacturaEquiposEspeciales':
                if (AutoEmisionCR.specialEquipmentFile !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.specialEquipmentFile.length; i++) {
                        lstFile.push(AutoEmisionCR.specialEquipmentFile[i])
                    }
                }
                return http(endPoints.sendNotficationNew).post(await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'EQUIPO_ESPECIAL', lstFile));
            case 'InspeccionVehiculo':
                if (AutoEmisionCR.frontCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.frontCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.frontCarImage[i])
                    }
                }
                if (AutoEmisionCR.backCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.backCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.backCarImage[i])
                    }
                }
                if (AutoEmisionCR.rightSideCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.rightSideCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.rightSideCarImage[i])
                    }
                }
                if (AutoEmisionCR.leftSideCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.leftSideCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.leftSideCarImage[i])
                    }
                }
                if (AutoEmisionCR.carPanelImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.carPanelImage.length; i++) {
                        lstFile.push(AutoEmisionCR.carPanelImage[i])
                    }
                }
                return http(endPoints.sendNotficationNew).post(await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'VEHICULO_USADO', lstFile));
            case 'RechazoEvicertia':
                return http(endPoints.sendNotficationNew).post(await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'NO_EVICERTIA', lstFile));

        }

    }

    const UploadFileToPol = async (type: typeNotificationAutoEmisionCR) => {
        let lstFile: Array<File> = [];

        switch (type) {
            case 'InspeccionVehiculo':
                if (AutoEmisionCR.frontCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.frontCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.frontCarImage[i])
                    }
                }
                if (AutoEmisionCR.backCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.backCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.backCarImage[i])
                    }
                }
                if (AutoEmisionCR.rightSideCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.rightSideCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.rightSideCarImage[i])
                    }
                }
                if (AutoEmisionCR.leftSideCarImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.leftSideCarImage.length; i++) {
                        lstFile.push(AutoEmisionCR.leftSideCarImage[i])
                    }
                }
                if (AutoEmisionCR.carPanelImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.carPanelImage.length; i++) {
                        lstFile.push(AutoEmisionCR.carPanelImage[i])
                    }
                }
                break;
            case "DocumentoIdentidad":
                if (AutoEmisionCR.identificationBackImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.identificationBackImage.length; i++) {
                        lstFile.push(AutoEmisionCR.identificationBackImage[i])
                    }
                }
                if (AutoEmisionCR.identificationFrontImage !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.identificationFrontImage.length; i++) {
                        lstFile.push(AutoEmisionCR.identificationFrontImage[i])
                    }
                }
                break;
            case 'FacturaProforma':
                if (AutoEmisionCR.invoiceFile !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.invoiceFile.length; i++) {
                        lstFile.push(AutoEmisionCR.invoiceFile[i])
                    }
                }
                break;
            case 'FacturaEquiposEspeciales':
                if (AutoEmisionCR.specialEquipmentFile !== undefined) {
                    for (let i = 0; i < AutoEmisionCR.specialEquipmentFile.length; i++) {
                        lstFile.push(AutoEmisionCR.specialEquipmentFile[i])
                    }
                }
                break
        }
        return http(endPoints.uploadFiles).post(await DataBuildFileToPol(lstFile, AutoEmisionCR.idPol));
    }


    const GetDataByPlate = (type: string, data: string) => {
        modalLoading.show(`Cargando datos de placa ${data}...`)
        http(endPoints.bienesMuebles(type, data)).get()
            .then((x) => {
                setAutoEmisionCR({
                    ...AutoEmisionCR,
                    vehicleChasis: x.chasis,
                    vehicleEngine: x.motor,
                    vehicleClass: x.codClaseVehiculoBS,
                    vehicleFuel: x.codCombustibleBS,
                    vehicleCylinderNumber: x.noCilindrosBS,
                    vehicleColor: x.color
                })
            }).finally(() => modalLoading.hide())
    }

    const IssuePolice = async (data: IAutoEmisionCR) => {
        modalLoading.show("Emitiendo póliza...");
        let policyCreated = false

        try {
            const policy = await http(endPoints.emissions(data.idPol)).get();

            if (policy.success) {
                setAutoEmisionCR({
                    ...data,
                    cnpoliza: policy.policy
                });
                policyCreated = true;
            }
            else
                modalMsg.setTextMsgWithClose(policy.errorMsg);

        } catch (error) {
            modalLoading.hide();
            return;
        }

        if (policyCreated) {
            try {
                modalLoading.show("Enviando correo de póliza...");
                await http(endPoints.sendNotficationNew).post(DataBuildNotificationPol(data, SitioOportunity.CR.AutoEmision, 'POLIZA'));
            } catch (error) {
                modalLoading.hide();
            }
            page.ViewPage(pagesType.Finish);
        }
        modalLoading.hide();
    }

    const Payment = async () => {
        const resultado = ValidateExpirationDate(AutoEmisionCR.cardExpirationDate);
        if (resultado) {
            modalMsg.setTextMsgWithClose(resultado);
            return;
        }
        try {
            const data = BuildPayment(AutoEmisionCR);
            modalLoading.show('Procesando pago...');

            const idPayment = await http(endPoints.paymentPay).post(data);

            modalLoading.show('Emitiendo póliza...');
            const resEmision = await http(endPoints.emissions(AutoEmisionCR.idPol)).get();

            const dataUpdate = {
                idPayment,
                cnpoliza: resEmision.policy
            };

            modalLoading.show('Actualizando póliza...');
            await http(endPoints.paymentUpdate2).put(dataUpdate);

            modalLoading.show('Aplicando pago...');
            const paymentResult = await http(endPoints.paymentApplyPayment(idPayment)).get();

            setAutoEmisionCR({
                ...AutoEmisionCR,
                statusAccount: paymentResult.estadoCuenta,
                transactionId: paymentResult.transactionId,
                cnpoliza: resEmision.policy
            });

            page.Increment();
            modalLoading.hide();

        } catch (error) {
            // Si falló la emisión, revertimos el pago (si ya se había iniciado)
            // if (typeof error === 'string' && error.includes('resEmision')) {
            //     try {
            //         await http(endPoints.paymentRevert(idPayment)).get();
            //     } catch (_) {
            //         // log opcional
            //     }
            // }

            modalLoading.hide();
            SendNotificationErrorPay();
        }
    };

    const SendNotificationErrorPay = async () => {
        modalLoading.show('Notificando...');
        await http(endPoints.sendNotficationNew).post(await DataBuildNotification(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'NO_PAGO', undefined))
            .finally(() => { modalLoading.hide(); modalErrorPV.show(); })
    }

    const DownloadReceipts = (id: string) => {
        modalLoading.show('Descargando recibo...');
        http(endPoints.paymentReceipt(id, true))
            .getWithoutParam()
            .catch(() => modalLoading.hide())
            .finally(() => {
                modalLoading.hide();
            })
    }

    const DownloadPolicy = (id: string) => {
        modalLoading.show('Descargando póliza....')
        http(endPoints.descargarPoliza(id)).get()
            .catch(() => modalLoading.hide())
            .finally(() => {
                modalLoading.hide();
            })
    }
    const SaveCard = () => {
        modalLoading.show('Guardando...')
        const data = BuildSaveCard(AutoEmisionCR)
        http(endPoints.paymentUpdate).post(data)
            .then(x => page.ViewPage(pagesType.PaymentFinish))
            .finally(() => modalLoading.hide())
    }

    const SendNotificationPolicy = () => http(endPoints.sendNotficationNew).post(DataBuildNotificationPol(AutoEmisionCR, SitioOportunity.CR.AutoEmision, 'POLIZA'));

    const SaveCardStep = () => {
        let lstPromise: Array<any> = []
        lstPromise.push(SendNotificationPolicy())
        if (AutoEmisionCR.acceptSaveCard === 'S')
            lstPromise.push(http(endPoints.paymentUpdate).post(BuildSaveCard(AutoEmisionCR)))

        modalLoading.show('Actualizando datos...')
        Promise.allSettled(lstPromise)
            .then(() => {
                page.ViewPage(pagesType.PaymentFinish);
            }).catch(() => {
                page.ViewPage(pagesType.PaymentFinish);
            }).finally(() => modalLoading.hide())
    }

    const Submit = () => {
        let result = document.querySelector("form") as HTMLFormElement;
        if (result.reportValidity() === false) return;

        switch (page.index) {
            case pagesType.personalData:
                SavePersonalData();
                break;
            case pagesType.personalDataSpouse:
                SavePersonalDataSpouse();
                break;
            case pagesType.VehicleDetails:
                //SaveVehicleDetail();
                ValidPlate();
                break;
            case pagesType.PV:
                Payment();
                break;
            case pagesType.SaveCard:
                //AutoEmisionCR.acceptSaveCard === 'S' ? SaveCard() : page.ViewPage(pagesType.PaymentFinish)
                SaveCardStep();
                break;
            case pagesType.UsedCarFile:
                SaveUsedcar();
                break;
            case pagesType.CICAC:
                SaveStepCICACKyc();
                break;
            default:
                page.Increment();
                break;
        }
    }

    const Back = () => {
        switch (page.index) {
            case pagesType.VehicleDetails:
                if (AutoEmisionCR.obligatedSubjectsPEPQuestion1 === 'S')
                    page.Decrement();
                else
                    page.ViewPage(pagesType.CICAC);
                break;
            case pagesType.UsedCarFile:
                page.ViewPage(pagesType.VehicleDetails)
                break;
            default:
                page.Decrement();
                break;
        }
    }

    const styleCss2 = {
        overlay: { background: 'rgba(255, 255, 255, 0.85)' }
    }

    const styleCssPV = {
        overlay: { background: 'rgba(255, 255, 255, 1)' }
    }

    const styleCenter: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }

    return (
        <div className='container'>
            <div className='layout-auto-cr'>
                {AutoEmisionCR.init === true && <>
                    {siteTitleMain[page.index] !== '' &&
                        <>
                            <div className="mt-10">
                                <p className="lbl-title title-1">{siteTitleMain[page.index]}</p>
                                <p className="lbl-title title-2">Con tu póliza de Auto LAFISE Plus, disfruta cada momento sin preocupaciones</p>
                            </div>
                            <LineProgressBar index={page.actualPage.indexBar} totalPages={SiteConfig.TotalPageBar} />
                        </>
                    }
                    <form>
                        <div style={{ display: "flex" }}>
                            <div className="step-container-auto-cr">
                                <PagesTitleCtrl {...page.actualPage} />
                                <Step {...page.actualPage} />
                            </div>
                        </div>
                        <ButtonCtrl data={page.actualPage} submit={Submit} back={Back} />
                        {page.index === pagesType.Evicertia &&
                            <div className='mt-20 mb-20' style={{ display: 'flex', justifyContent: 'center' }}>
                                <button className='btn-auto-cr  back-auto-cr' type="button" onClick={SendNotificationEvicertia2}>Firma del asegurado</button>
                            </div>
                        }
                        {page.index === pagesType.PaymentFinish &&
                            <div className='mb-20' style={{ display: 'flex', justifyContent: 'center' }}>
                                <button className='btn-auto-cr  next-auto-cr' type="button" onClick={() => page.ViewPage(pagesType.Finish)}>Siguiente</button>
                            </div>
                        }
                    </form>
                </>}
            </div>
            <ModalMsgCtrl {...modalLoading.modal} closeModal={modalLoading.hide} />
            <Modal className="modal"
                isOpen={modalWaitEvicertia.modal.active} ariaHideApp={false} style={styleCss2} >
                <div className='pt-20 pb-20'>
                    <div>
                        <p className="text-center lbl-color-secondary modal-lbl modal-lbl-t1 mt-50">Esta a un paso de su nueva póliza</p>
                    </div>
                    <div className='img-wm' >
                        <IconWaitEvicertia />
                    </div>
                    <div className="">
                        <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">
                            Favor revisar su correo electrónico para la aceptación o rechazo de los documentos
                            de tu póliza, posterior retorne a esta página para continuar con la emisión de su póliza
                        </p>
                    </div>
                </div>
            </Modal>
            <Modal className="modal"
                isOpen={modalInvalidRequirements.modal.active} ariaHideApp={false} style={styleCss2} >
                <div className='pt-20 pb-20'>
                    <div className='img-wm' >
                        <IconError />
                    </div>
                    <div className="">
                        <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">
                            Un ejecutivo de Seguros LAFISE se comunicará con usted lo antes posible
                        </p>
                    </div>
                </div>
            </Modal>
            <Modal isOpen={modalErrorPV.modal.active} style={styleCssPV} className='modal'>
                <div className='pb-20 pt-20'>
                    <label style={{ ...styleCenter, textAlign: 'center', fontSize: '20px', color: '#FF0000', lineHeight: '30px' }}>¡Ha ocurrido un error!</label>
                    <div className='mt-40 mb-40' style={styleCenter}>
                        < IconError />
                    </div>
                    <p style={{ textAlign: 'center', fontSize: '15px', color: '#4D4D4D', lineHeight: '22px' }}>
                        No hemos podido procesar su <br></br> solicitud, actualice su método <br></br> de pago o proporcione otro e <br></br> inténtelo nuevamente.
                    </p>
                    <p style={{ textAlign: 'center', fontSize: '15px', color: '#4D4D4D', lineHeight: '22px' }}>
                        Si desea que un ejecutivo de <br></br> <strong>Seguro LAFISE</strong> lo contante para  <br></br> continuar con la gestión vía <br></br> telefónica de clic en <br></br> ¨Contáctenme¨
                    </p>
                    <div style={styleCenter} className='mt-30 mb-30'>
                        <button className='btn-auto-cr back-auto-cr' onClick={() => modalErrorPV.hide()} type="button">Reintentar</button>
                    </div>

                    <div style={styleCenter} className='mt-20 mb-30'>
                        <button className='btn-auto-cr next-auto-cr' >Contacteme</button>
                    </div>
                </div>
            </Modal>

            <Modal isOpen={modalPlateExists.modal.active} style={styleCssPV} className='modal'>
                <div className='pb-20 pt-20'>
                    <label style={{ ...styleCenter, textAlign: 'center', fontSize: '20px', color: '#FF0000', lineHeight: '30px' }}>¡Ha ocurrido un error!</label>
                    <div className='mt-40 mb-40' style={styleCenter}>
                        < IconError />
                    </div>
                    <p style={{ textAlign: 'center', fontSize: '15px', color: '#4D4D4D', lineHeight: '22px' }}>
                        La placa ingresada ya cuenta  <br></br>  con una póliza activa en  <br></br>  Seguros LAFISE  </p>

                    <div style={styleCenter} className='mt-30 mb-30'>
                        <button className='btn-auto-cr back-auto-cr' onClick={() => modalPlateExists.hide()} type="button">Regresar</button>
                    </div>
                    {/* 
                    <div style={styleCenter} className='mt-20 mb-30'>
                        <button className='btn-auto-cr next-auto-cr'>Finalizar</button>
                    </div> */}
                </div>
            </Modal>
            <Modal className="modal"
                isOpen={modalUrlNoValid.modal.active} ariaHideApp={false} style={styleCss2} >
                <div className='pt-20 pb-20'>
                    <div className='img-wm' >
                        <IconError />
                    </div>
                    <div className="">
                        <p className="text-center modal-lbl lbl-color modal-lbl-t2 mb-50">
                            Lo sentimos, este URL no esta disponible
                        </p>
                    </div>
                </div>
            </Modal>
            <ModalMsgCtrl {...modalMsg.modal} closeModal={modalMsg.hide} />

        </div >

    )
}

export default Auto_Emision_CR;